// Прилипающий header
itsoftApp.createModule("fixedMenu", function() {
    var header = $("header");

    $(window).on("load scroll", function() {
        if ($(this).scrollTop() > 70) {
            header.addClass("fixed");
        }
        else {
            header.removeClass("fixed");
        }
    });
});
